module.exports = "<div class=\"weui_tab\">\n  <slot name=\"navbar\"></slot>\n  <div class=\"weui_tab_bd\">\n    <slot name=\"body\"></slot>\n  </div>\n  <slot name=\"tabbar\"></slot>\n</div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./components/tab/tab.vue
 ** module id = 134
 ** module chunks = 0
 **/